import { MRT_ColumnDef } from 'material-react-table'

import { renderLastChanged, renderStatusCell } from '../../utils'

import { useCanEdit } from '.'

export const platformParams = {
  PLATFORM_ID: { name: 'platformId', label: 'Id' },
  PLATFORM_NAME: { name: 'platformName', label: 'Name' },
  PLATFORM_CODE: { name: 'platformCode', label: 'Code' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  STATUS: { name: 'status', label: 'Status' },
  ACTION: { name: 'action', label: 'Action' },
}

export const productParams = {
  PRODUCT_ID: { name: 'productId', label: 'Id' },
  PRODUCT_NAME: { name: 'productName', label: 'Name' },
  PRODUCT_CODE: { name: 'productCode', label: 'Code' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  STATUS: { name: 'status', label: 'Status' },
  ACTION: { name: 'action', label: 'Action' },
}

export const countryParams = {
  COUNTRY_ID: { name: 'countryId', label: 'Id' },
  COUNTRY_NAME: { name: 'countryName', label: 'Name' },
  COUNTRY_CODE: { name: 'countryCode', label: 'Country code' },
  CODE: { name: 'code', label: 'Code' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  STATUS: { name: 'status', label: 'Status' },
  ACTION: { name: 'action', label: 'Action' },
}

export const providerParams = {
  PROVIDER_ID: { name: 'providerId', label: 'Id' },
  PROVIDER_NAME: { name: 'providerName', label: 'Name' },
  PAYMENT_MODE: { name: 'paymentMode', label: 'Payment mode' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  STATUS: { name: 'status', label: 'Status' },
  ACTION: { name: 'action', label: 'Action' },
}

export const paymentModeParams = {
  PAYMENT_ID: { name: 'paymentId', label: 'Id' },
  PAYMENT_NAME: { name: 'paymentName', label: 'Name' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  STATUS: { name: 'status', label: 'Status' },
  ACTION: { name: 'action', label: 'Action' },
}

export const mappingParams = {
  ID: { name: 'id', label: 'Id' },
  PROVIDER_ID: { name: 'providerId', label: 'Provider id' },
  PLATFORM_ID: { name: 'platformId', label: 'Platform id' },
  PLATFORM_NAME: { name: 'platformName', label: 'Platform name' },
  LAST_MODIFIED_DATE: { name: 'modifiedDate', label: 'Last changed' },
  LAST_MODIFIED_BY: { name: 'modifiedBy', label: 'Last modified' },
  ACTION: { name: 'action', label: 'Action' },
  IS_MAPPED: { name: 'isMapped', label: 'Is mapped' },
}

export const providerColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: providerParams.STATUS.name,
    header: providerParams.STATUS.label,
    size: 0,
    Cell: renderStatusCell,
  },
  {
    accessorKey: providerParams.PROVIDER_ID.name,
    header: providerParams.PROVIDER_ID.label,
    size: 40,
  },
  {
    accessorKey: providerParams.PROVIDER_NAME.name,
    header: providerParams.PROVIDER_NAME.label,
    size: 200,
  },
  {
    accessorKey: providerParams.PAYMENT_MODE.name,
    header: providerParams.PAYMENT_MODE.label,
    size: 80,
  },
  {
    accessorKey: providerParams.LAST_MODIFIED_DATE.name,
    header: providerParams.LAST_MODIFIED_DATE.label,
    size: 250,
    Cell: renderLastChanged,
  },
  {
    accessorKey: 'id',
    header: 'Action',
    size: 10,
    Cell: useCanEdit,
    enableSorting: false,
  },
]

export const paymentModeColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: paymentModeParams.STATUS.name,
    header: paymentModeParams.STATUS.label,
    size: 0,
    Cell: renderStatusCell,
  },
  {
    accessorKey: paymentModeParams.PAYMENT_ID.name,
    header: paymentModeParams.PAYMENT_ID.label,
    size: 0,
  },
  {
    accessorKey: paymentModeParams.PAYMENT_NAME.name,
    header: paymentModeParams.PAYMENT_NAME.label,
    size: 200,
  },
  {
    accessorKey: paymentModeParams.LAST_MODIFIED_DATE.name,
    header: paymentModeParams.LAST_MODIFIED_DATE.label,
    size: 250,
    Cell: renderLastChanged,
  },
  {
    accessorKey: 'id',
    header: 'Action',
    size: 10,
    Cell: useCanEdit,
    enableSorting: false,
  },
]

export const mappingColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: mappingParams.ID.name,
    header: mappingParams.ID.label,
    size: 41,
  },
  {
    accessorKey: mappingParams.PROVIDER_ID.name,
    header: mappingParams.PROVIDER_ID.label,
    size: 10,
  },
  {
    accessorKey: mappingParams.PLATFORM_ID.name,
    header: mappingParams.PLATFORM_ID.label,
    size: 41,
  },
  {
    accessorKey: mappingParams.PLATFORM_NAME.name,
    header: mappingParams.PLATFORM_NAME.label,
    size: 100,
  },
  {
    accessorKey: mappingParams.LAST_MODIFIED_DATE.name,
    header: mappingParams.LAST_MODIFIED_DATE.label,
    size: 60,
    Cell: renderLastChanged,
  },

  {
    accessorKey: mappingParams.IS_MAPPED.name,
    header: mappingParams.IS_MAPPED.label,
    size: 100,
  },
  {
    accessorKey: 'id',
    header: 'Action',
    size: 10,
    Cell: useCanEdit,
    enableSorting: false,
  },
]

export const mappingFilter = [
  {
    title: 'Payment provider',
    options: [
      { label: 'Active', value: true, field: 'isActive' },
      { label: 'Inactive', value: false, field: 'isActive' },
    ],
  },
]

export const modelTitles = {
  CREATE_PRODUCT: 'Create product',
  EDIT_PRODUCT: 'Update product',
  CREATE_PLATFORM: 'Create platform',
  EDIT_PLATFORM: 'Update platform',
  CREATE_COUNTRY: 'Create country',
  EDIT_COUNTRY: 'Update country',
  CREATE_PAYMENT_MODE: 'Create payment mode',
  UPDATE_PAYMENT_MODE: 'Update payment mode',
  CREATE_PROVIDER: 'Create provider',
  UPDATE_PROVIDER: 'Update provider',
  CREATE_MAPPING: 'Create mapping',
  UPDATE_MAPPING: 'Update mapping',
}

export const buttonTitles = {
  CREATE: 'Create',
  UPDATE: 'Update',
}
